<template>
  <div :id="'component-' + _uid">
    <div class="video">
      <a href @click.prevent="dialogVisible = true" class="video__link">
        <div class="video__meta">
          <span class="video__title">{{ video.title }}</span>
          <span class="video__date">{{ moment(video.dateCreated).format(dateFormat) }}</span>
        </div>
      </a>
      <img :src="video.url" class="video__image"/>
    </div>

    <el-dialog
      v-if="dialogVisible"
      :append-to-body="true"
      :title="video.title"
      :visible.sync="dialogVisible"
      custom-class="media--video"
    >

      <div class="dialog__embed" v-if="video.videoEmbed && video.videoEmbed.length > 0">
        <iframe
          class="embed"
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen
          frameborder="0"
          :src="video.videoEmbed[0].videoUrl"
          :width="video.videoEmbed[0].width"
          :height="video.videoEmbed[0].height"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import fitvids from 'fitvids';
  import moment from 'moment';
  import constants from '@/constants';

  export default {
    name: 'MediaVideoExcerpt',
    data(){
      return {
        dialogVisible: false,
        dateFormat: constants.DATE_FORMAT
      };
    },
    props: [
      'video'
    ],
    methods: {
      moment
    },
    watch: {
      dialogVisible
    }
  }

  //////////

  function dialogVisible() {
    // Use setTimeout to wait for element to render. 0 seconds will wait for the next event loop tick.
    setTimeout(() => {
      fitvids('#component-' + this._uid);
    }, 0);
  }
</script>

<style lang="scss" scoped>

  .video {
    display: block;
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    overflow: hidden;
    margin: 20px 0;

    &__link {
      z-index: 2;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,1) 100%);
    }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__meta {
      position: absolute;
      width: 100%;
      height: auto;
      left: 0;
      bottom: 0;
      padding: 16px;
      color: white;
    }

    &__title,
    &__date {
      display: block;
      font-size: 12px;
    }

    &__title {
      font-weight: 700;
    }
  }

  .embed {
    margin: 0;
    padding: 0;
  }


  .el-dialog {
    position: relative;
    width: 90%;
    max-width: 66%;
    max-height: calc(76% + 60px);
    margin: auto !important;

    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__body{
      .dialog__embed {
        padding-top: 0;
      }
    }
  }

</style>
